import {
  Alert,
  Button,
  Card,
  Col,
  FormInstance,
  List,
  notification,
  Popover,
  Row,
  Tag,
  Typography,
} from 'antd';
import React, { useContext, useState } from 'react';
import Title from 'components/Title';
import GoogleMapReact from 'google-map-react';
import { EnvironmentOutlined, PlusOutlined } from '@ant-design/icons';
import {
  AssetAddress,
  createAssetAddress,
  deleteAssetAddress,
  getAssetAddresListByassetid,
  updateAssetAddres,
} from 'services/assets';
import { useQuery } from 'react-query';
import { isEmpty, isNil } from 'lodash';
import ModalControllerNV from 'components/ModalControllerNV';
import AssetAdressModal from './AssetAdressModal';
import Popconfirm from 'antd/lib/popconfirm';
import EditButton from 'components/EditButton';
import DeleteButton from 'components/DeleteButton';
import GetLabel from 'DisplayFramework/components/GetLabel';
import AddAssetAdressModal from './AddAssetAdresseModal';
import { AuthContext } from 'components/Auth/Auth';
import getEnvValue from 'utils/getEnvValue';

export type AddressProps = {
  form: FormInstance;
  assetid: number;
  showAsModal?: boolean;
  allowClear?: boolean;
  isActive?: boolean;
};

export type marker = {
  lat: number;
  lng: number;
};

const AssetAdress = (props: AddressProps) => {
  const { isInspect } = useContext(AuthContext);
  const { assetid,isActive } = props;

  const [center, setcenter] = useState<marker>({
    lat: 48.850405482007325,
    lng: 2.355450591735724,
  });

  const {
    data: listAdress,
    refetch,
    isFetching,
  } = useQuery(
    ['getAssetAddresListByassetid', assetid],
    () =>
      getAssetAddresListByassetid({ assetid }).then((res) => {
        if (!isEmpty(res.list) && isNil(selectedID)) {
          setselectedID(res.list[0].assetadrid);
          setcenter({
            lat: Number(res.list[0].assetgpslat),
            lng: Number(res.list[0].assetgpslng),
          });
        }
        return res.list || [];
      }),
    {
      staleTime: 60 * 1000,
      enabled: !isNil(assetid) && isActive !== false,
    }
  );
  const [position, setPosition] = useState<marker>({
    lat: 0,
    lng: 0,
  });


  const [pickPlace, setpickPlace] = useState(false);
  const [add, setAdd] = useState(false);
  const [mark, setMark] = useState();
  const [addresseid, setaddresseid] = useState(0);
  const [zoom, setzoom] = useState(8);
  const [selectedID, setselectedID] = useState<number>();
  const Marker = ({ onClick, content, title, assetadrid }: any) => (
    <Popover content={content} title={title} trigger="hover">
      <Button
        onClick={onClick}
        type="link"
        icon={
          <EnvironmentOutlined
            style={{
              color: assetadrid === selectedID ? 'white' : 'red',
              fontSize: '25px',
            }}
          />
        }
      />
    </Popover>
  );
  const handlecreateadress = async (lng: number, lat: number) => {
    const assetAddressRequest: AssetAddress = {
      adrenddate: '' as any,
      adrstartdate: '' as any,
      adrstatus: '' as any,
      adrstatusdate: '' as any,
      adrtype: '' as any,
      assetadrid: '' as any,
      assetid:assetid,
      assetmainadrcity: '' as any,
      assetmainadrcountry: '' as any,
      assetmainadrregion: '' as any,
      assetmainadrstreet1: '' as any,
      assetmainadrstreet2: '' as any,
      assetmainadrzipcode: '' as any,
      assetgpslng: String(lng),
      assetgpslat: String(lat),
    };

    if ((pickPlace)||(add) ){
      await createAssetAddress({ assetid, assetAddressRequest })
        .then((res) => {
          notification.success({ message: res.message });
          refetch();
          setselectedID(res.data.assetadrid);
          setpickPlace(false);
          setAdd(false);
        })
        .catch((res) => {
          notification.error({ message: res.message });
          setAdd(false);
        });
    }
  };
  const [isLoading, setisLoading] = useState(false);
  const handleDeleteAddress = async (assetadrid: any) => {
    await deleteAssetAddress({ assetadrid, assetid })
      .then((res) => {
        notification.success({ message: res.message });
        refetch();
      })
      .catch((res) => {
        notification.error({ message: res.message });
      });
  };
  const handleUpdateLatLng = async (mark: any) => {
    const assetAddressRequest: AssetAddress = {
      assetgpslng: String(position.lng),
      assetgpslat: String(position.lat),
      adrenddate: mark?.adrenddate,
      adrstartdate: mark?.adrstartdate,
      adrstatus: mark?.adrstatus,
      adrstatusdate: mark?.adrstatusdate,
      adrtype: mark?.adrstatusdate,
      assetadrid: mark?.assetadrid,
      assetid: mark?.assetid,
      assetmainadrcity: mark?.adrstatusdate,
      assetmainadrcountry: mark?.assetmainadrcountry,
      assetmainadrregion: mark?.assetmainadrregion,
      assetmainadrstreet1: mark?.assetmainadrstreet1,
      assetmainadrstreet2: mark?.assetmainadrstreet2,
      assetmainadrzipcode: mark?.assetmainadrzipcode,
    };

    await updateAssetAddres({
      assetid: mark?.assetid,
      assetadrid: mark?.assetadrid,
      assetAddressRequest,
    })
      .then((res) => {
        notification.success({ message: res.message });
        refetch();
        setisLoading(false);
      })
      .catch((err) => {
        notification.error({ message: err.message });
      });
  };

  return (
    <Card title={<GetLabel label="assetAddress" style={{fontWeight:'bold',paddingLeft:15}}/>}>
      <Row gutter={8}>
      {getEnvValue('hideMaps')===false ?(
        <Col style={{ height: '70vh', width: '100%' }} span={14}>
          {pickPlace && (
            <Row justify="center">
              <Alert
                style={{ width: '100%' }}
                message="Please click on the map in any area to add new adress"
                type="info"
                closeText="Close"
              />
            </Row>
          )}
          <GoogleMapReact
            onClick={(ev) => {
              setPosition(ev);
              {
                add === true
                  ? handlecreateadress(ev.lng, ev.lat)
                  : handleUpdateLatLng(mark);
              }
            }}
            center={center}
            zoom={zoom}
          >
            {listAdress?.map((mark, i) => {
              return (
                <Marker
                  key={i}
                  onClick={(ev: any) => {
                    setselectedID(mark.assetadrid);

                    setpickPlace(false);
                    setMark(ev.mark);
                  }}
                  lat={mark.assetgpslat}
                  lng={mark.assetgpslng}
                  content={mark.assetmainadrcitylabel}
                  title={mark.assetmainadrcountrylabel}
                  assetadrid={mark.assetadrid}
                  draggable
                />
              );
            })}
          </GoogleMapReact>
        </Col>):''}
        <Col
          style={{
            height: '70vh',
            width: '100%',
            overflow: 'scroll',
            padding: 10,
            float:'left'
          }}
          span={!getEnvValue('hideMaps')===false ?24:10}
        >
          <List
            size="small"
            header={
              <Row>
                <Col span={19}>
                  <Title comcode="listAdress" level={4}></Title>
                </Col>
                <Col span={4}>
                  <ModalControllerNV
                    modal={({ setVisible, visible }) => (
                      <AddAssetAdressModal
                        onClose={() => setVisible(false)}
                        visible={visible}
                        assetid={assetid}
                        refetech={refetch}
                        pickPlace={pickPlace}
                        setpickPlace={setpickPlace}
                      />
                    )}
                    content={({ setVisible, visible }) => (
                      <Button
                        type="primary"
                        icon={
                          <PlusOutlined
                            onClick={() => isInspect && setVisible(true)}
                          />
                        }
                        onClick={() => {
                          setAdd(true);setVisible(true);
                        }}
                      >
                        <GetLabel label="addAddresse" />
                      </Button>
                    )}
                  />
                </Col>
              </Row>
            }
            footer={getEnvValue('hideMaps') === false &&
              <div>
                <Typography.Paragraph italic>
                  <strong>NB:</strong>&nbsp; please click on target button to
                  pick place, when click on map data will be set as new by
                  default you can change it by edit or delete the marker
                </Typography.Paragraph>
              </div>
            }
            bordered
            dataSource={listAdress ?? []}
            renderItem={(item) => (
              <List.Item
                actions={[
                  <ModalControllerNV
                    key={item.assetadrid}
                    modal={({ setVisible, visible }) => (
                      <AssetAdressModal
                        assetid={assetid}
                        refetech={refetch}
                        assetadrid={item.assetadrid}
                        onClose={() => setVisible(false)}
                        visible={visible}
                        pickPlace={pickPlace}
                        setpickPlace={setpickPlace}
                        position={position}
                        setisLoading={setisLoading}
                        isLoading={isLoading}
                      />
                    )}
                    content={({ setVisible, visible }) => (
                      <EditButton
                        onlyIcon
                        onClick={() => {
                          setVisible(true);
                          setAdd(!add);
                        }}
                      />
                    )}
                  />,

                  <Popconfirm
                    key={item.assetadrid}
                    title="Are you sure to delete this address?"
                    onConfirm={() => {
                      handleDeleteAddress(item.assetadrid);
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <DeleteButton onlyIcon />
                  </Popconfirm>,
                ]}
              >
                <List.Item.Meta
                  title={
                    getEnvValue('hideMaps') === false ?
                    <strong>
                      <a
                        key={item.assetadrid}
                        onClick={() => {
                          setaddresseid(Number(item.assetadrid));
                          setcenter({
                            lat: Number(item.assetgpslat),
                            lng: Number(item.assetgpslng),
                          });
                          setzoom(10);
                          setselectedID(item.assetadrid);
                        }}
                      >
                        {item.assetmainadrcountrylabel}
                      </a>
                    </strong>
                    :  <strong>
                    {item.assetmainadrcountrylabel}
                  </strong>
                  }
                  description={
                    getEnvValue('hideMaps') === false ?
                    <a
                      key={item.assetadrid}
                      onClick={() => {
                        setcenter({
                          lat: Number(item.assetgpslat),
                          lng: Number(item.assetgpslng),
                        });
                        setzoom(10);
                        setselectedID(item.assetadrid);
                      }}
                    >
                      {/* {item.adrtype +
                        ' : ' + */}
                      {item.assetmainadrcitylabel +
                        ' - ' +
                        item.assetmainadrstreet1}
                    </a>
                    :  <strong>
                 
                      {item.assetmainadrcitylabel +
                        ' - ' +
                        item.assetmainadrstreet1}
                
                  </strong>
                  }
                />
                <div>
                  <Tag
                    key={item.assetadrid}
                    color={
                      item.adrstatus === 'INIT'
                        ? 'geekblue'
                        : item.adrstatus === 'END'
                        ? 'red'
                        : 'green'
                    }
                  >
                    {item.adrstatuslabel}
                  </Tag>
                </div>
              </List.Item>
            )}
          />
        </Col>
      </Row>
    </Card>
  );
};
export default AssetAdress;
